import FilesCard from '@components/cards/files/Files.card';
import { Stack, Typography } from '@mui/material';
import {AuditInformation} from '@store/audits/audits-information/audits-information.model';
import { DocumentKind } from '@store/files';
import { useState } from 'react';
interface ObservationProps {
  auditInformation: AuditInformation;
}

const Observation = (props: ObservationProps) => {

  const [documents] = useState(props.auditInformation.documents);

  return (
    <Stack direction="row" alignItems="center" height="100%">
        <Stack direction='row'>
            <Stack sx={{
                backgroundColor: '#E9EBEE',
                borderRadius: '1px',
                padding: '6px 10px',
                width: 'fit-content'
            }}>
                <Typography fontSize="12px" fontWeight={400} color="#192133">
                    {props.auditInformation.description}
                </Typography>
            </Stack>
        </Stack>

      <Stack direction="row" spacing={2} justifySelf="start" alignSelf="start">
        {documents?.length !== 0 && documents?.map((currentDoc) => {
          return (
              <FilesCard document={{
                id: currentDoc?.id ?? 0,
                name: currentDoc?.name ?? '',
                description: '',
                documentKind: currentDoc?.documentKind ?? DocumentKind.ISSUE,
                filename: '',
                mimetype: currentDoc?.mimetype ?? 'image/png',
              }}/>
          );
        } )}
      </Stack>
    </Stack>
  );
};

export default Observation;
